import type { KnownFeatureFlags } from './featureFlagSlice'
import { useReduxSelector } from '../hooks/useReduxSelector'

export function useIsFeatureFlagEnabled(featureName: keyof KnownFeatureFlags) {
  const isFeatureFlagEnabled = useReduxSelector((state) => state.featureFlags?.[featureName])

  return isFeatureFlagEnabled
}
